import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { Dialog } from "primereact/dialog";
import React, { useEffect, useState, useMemo, FC, useRef } from "react";
import { InputTextComponents } from "../../../InputTextComponents/InputTextComponents";
import { ValidateRefTemplate } from "../../../../Services/TemplateService";
import useAlert from "../../../../hooks/useAlert";
import {
  GetRefDocTemp,
  MAdvanceFormByMemoIds,
} from "../../../../Services/MemoService";
import useMasterSetting from "../../../../hooks/useMasterSetting";
import { useLocation, useHistory } from "react-router-dom";
import { Col, Row, Button } from "antd";
import "./index.css";

type Props = {
  refAttribute: any;
  dialogVisibleInRefTemplate: any;
  setDialogVisibleInRefTemplate: any;
  refTempSelected: any[];
  refObtions: any[];
  setRefTempSelected: any;
  setSearchRefDocData: any;
  searchRefDocData: any;
  previousRefTempSelected: any;
  setIsControlLoading: any;
  memoDetail: any;
  listRefDocDetails: any;
  listFormNames: any;
  checkRefTemplate: (
    listFormNames: any,
    listRefDocDetails: any,
    res: any,
    _RefID: any
  ) => void;
};

const DialogRefTemplateComponent = (props: Props) => {
  const { search, pathname } = useLocation();
  const { masterSetting, getMasterSetting } = useMasterSetting();
  const [filterRefTempValue, setFilterRefTempValue] = useState<string>("");
  const [refSelected, setRefSelected] = useState<any[]>(props.refTempSelected);
  const [loading, setLoading] = useState(false);
  const [refLoading, setRefLoading] = useState<boolean>(false);
  const masterRefCol = masterSetting["AddRefCol"];
  const query = useMemo(() => new URLSearchParams(search), [search]);
  const [displayData, setDisplayData] = useState<any[]>([]);
  const [allFetchedData, setAllFetchedData] = useState<any[]>([]); // เก็บข้อมูลที่ fetch มา

  const assignMAdvancveForm = (
    selectedList: any[],
    advanceFormList: Array<{ MemoId: number; MAdvancveForm: string }>
  ) => {
    try {
      return selectedList.map((x) => {
        let matchedItem = advanceFormList.find((y) => y.MemoId == x.MemoId);
        if (matchedItem != null) {
          x.MAdvancveForm = matchedItem.MAdvancveForm;
        } else {
          x.MAdvacveForm = "[]";
        }
        return x;
      });
    } catch (err) {
      console.log(err);
    }
  };

  // useEffect(() => {
  //   if (props.dialogVisibleInRefTemplate) {
  //     setFilterRefTempValue("");
  //     console.log("refAttribute", props.refAttribute);

  //     if (props.refAttribute.mode.toLowerCase() === "multiselect") {
  //       // ถ้า mode เป็น multiselect ก็แสดงทั้งหมด
  //       if (props.refTempSelected?.length > 0) {
  //         setDisplayData(props.refAttribute.option || []);
  //       } else {
  //         // ไม่มี ref เปิดมาให้ว่าง
  //         setDisplayData([]);
  //       }
  //     } else {
  //       // ถ้า mode เป็น single ให้แสดงว่าง
  //       setDisplayData([]);
  //     }
  //   }
  // }, [props.dialogVisibleInRefTemplate]);

  useEffect(() => {
    if (props.dialogVisibleInRefTemplate) {
      setFilterRefTempValue("");
      setDisplayData([]); // เปิดมาว่างๆ รอให้กด Search
      setAllFetchedData([]);
    }
  }, [props.dialogVisibleInRefTemplate]);

  useEffect(() => {
    try {
      if (refSelected) {
        if (
          JSON.stringify(refSelected) !== JSON.stringify(props.refTempSelected)
        ) {
          if (props.refAttribute.mode.toLowerCase() === "single") {
            onHide();
          }
        }
      }
    } catch (error) {}
  }, [refSelected]);

  const onSearchRefDoc = () => {
    try {
      const keyword = filterRefTempValue.toLowerCase();

      // ถ้าไม่ได้กรอกอะไร แสดงทั้งหมด
      if (!keyword) {
        setDisplayData(props.refAttribute.option || []);
        return;
      }

      // Search ได้ทุก column DocumentNo, TemplateName, MemoSubject และ optionLabel ที่กำหนดมา
      const data = props.refAttribute.option.filter((data: any) => {
        return (
          data.DocumentNo?.toLowerCase().includes(keyword) ||
          data.TemplateName?.toLowerCase().includes(keyword) ||
          data.MemoSubject?.toLowerCase().includes(keyword) ||
          data[props.refAttribute.optionLabel]
            ?.toLowerCase()
            .includes(keyword)
        );
      });

      setDisplayData(data);
    } catch (error) {
      console.log("search error", error);
    }
  };

  const renderHeaderRefTemplate = () => {
    return (
      <div>
        <Row gutter={8}>
            <InputTextComponents
              setClassNameProps="set-input-search-dialog"
              valueProps={filterRefTempValue}
              onChangeProps={(e: any) => setFilterRefTempValue(e)}
              placeholderProps={"Search"}
              setIconProps={<i className="pi pi-search" />}
              setClassNameSpanProps={"p-input-icon-left set-span-search-dialog "}
              onKeyDownProps={(e: any) => {
                if (e.key === "Enter") {
                  fetchAndSearch();
                }
              }}
              setStyleProps={{ width: "200px" }}
            />

            <button
              className="p-button p-component"
              onClick={fetchAndSearch}
              style={{marginLeft:"8px", padding:"0 12px"}}
            >
              <span>Search</span>
            </button>
        </Row>
      </div>
    );
  };

  const onHide = () => {
    if (refSelected && refSelected.length > 0) {
      props.setIsControlLoading(true);

      MAdvanceFormByMemoIds(refSelected.map((x) => x.MemoId),props.memoDetail.template_id).then(
        (refMemoId) => {
        const RefSelected = assignMAdvancveForm(refSelected, refMemoId);

        props.setRefTempSelected(RefSelected);
        }
      );
    }
    props.setDialogVisibleInRefTemplate(false);
    setFilterRefTempValue("");
    setDisplayData([]);
  };

  async function onSelect(refTemp: any) {
    const validate = await ValidateSelected(refTemp);

    if (validate) {
      try {
        if (refTemp === null) {
          setRefSelected([...[]]);
        } else if (!refTemp) {
          setRefSelected([]);
        } else if (Array.isArray(refTemp)) {
          setRefSelected([...refTemp]);
        } else {
          if (Array.isArray(refTemp)) {
            setRefSelected([...refTemp]);
          } else {
            if (Array.isArray(refTemp)) {
              setRefSelected([...refTemp]);
            } else {
              let val: any[] = [];
              val.push(refTemp);
              setRefSelected([...val]);
            }
          }
        }
      } catch (error) {
        console.log("ref=>error", error);
      }
    }
  }
  const { toggleAlert } = useAlert();

  async function ValidateSelected(refTempSelected: any) {
    let respone;
    let valid: boolean = true;
    let val: any[] = [];
    if (refTempSelected) {
      if (Array.isArray(refTempSelected)) {
        val = refTempSelected;
      } else {
        val.push(refTempSelected);
      }
      for (let i = 0; i < val.length; i++) {
        if (val[i].SelectField) {
          const dataJson = {
            TemplateId: props.memoDetail.template_id,
            Label: val[i].SelectField.label,
            DocNo: val[i].SelectField.value,
            Subject: val[i].MemoSubject,
            DocumentNo: val[i].DocumentNo,
          };
          respone = await ValidateRefTemplate(dataJson);
          if (respone.ValidateRef === false) {
            toggleAlert({
              description: respone.Message,
              message: "Reference Document Warning.",
              type: "warning",
              duration: 6,
            });
            valid = false;
          }
        }
      }
      return valid;
    }
  }

  const getRefDoc = async () => {
    setLoading(true);

    try {
      const refId = query.get("RefID") ?? "";

      const {
        memoDetail: { template_id, company_id, requestor, creator },
        listFormNames,
        listRefDocDetails,
        checkRefTemplate,
      } = props;

      const res = await GetRefDocTemp({
        template_ID: template_id,
        company_id,
        requestor,
        creator,
      });

      if (res) {
        checkRefTemplate(listFormNames, listRefDocDetails, res, refId);
      }
    } catch (error) {
      console.error("getRefDoc error:", error);
    } finally {
      setLoading(false);
      setRefLoading(false);
    }
  };

  const refColumnsDynamic = () => {
    if (!masterRefCol?.IsActive) return null;

    return masterRefCol?.Value1?.split("|").map(
      (colName: string, index: number) => {
        const headtexts = masterRefCol?.Value2?.split("|") || [];
        const headtext = headtexts[index] ?? "";

        const subtexts = masterRefCol?.Value3?.split("|") || [];
        const subtext = subtexts[index] ?? "";

        const bodyTemp = (rowData: any) => {
          if (colName.toLowerCase() === "companycode" && rowData.CompanyName) {
            return rowData.CompanyName.split(":")[0].trim();
          }
          return rowData[colName];
        };

        return (
          <Column
            key={index}
            field={colName}
            body={bodyTemp}
            header={
              <div>
                <span className="row headtext">{headtext}</span>
                <span className="row subtext">{subtext}</span>
              </div>
            }
            style={{ minWidth: "16rem" }}
          />
        );
      }
    );
  };

  const fetchAndSearch = async () => {
    setLoading(true);
    try {
      const refId = query.get("RefID") ?? "";
      const {
        memoDetail: { template_id, company_id, requestor, creator },
        listFormNames,
        listRefDocDetails,
        checkRefTemplate,
      } = props;

      // เรียก API ทุกครั้งที่กด Search
      const res = await GetRefDocTemp({
        template_ID: template_id,
        company_id,
        requestor,
        creator,
      });

      if (res) {
        // update refAttribute option ใน checkRefTemplate
        checkRefTemplate(listFormNames, listRefDocDetails, res, refId);

        // เก็บ raw data ไว้ filter
        setAllFetchedData(res);

        // filter ด้วย keyword
        applyFilter(res);
      }
    } catch (error) {
      console.error("fetchAndSearch error:", error);
    } finally {
      setLoading(false);
    }
  };

  // filter จาก data ที่ fetch มา
  const applyFilter = (data: any[]) => {
    const keyword = filterRefTempValue.toLowerCase().trim();
    if (!keyword) {
      setDisplayData(data);
      return;
    }

    const filtered = data.filter((item: any) => {
      return (
        item.DocumentNo?.toLowerCase().includes(keyword) ||
        item.TemplateName?.toLowerCase().includes(keyword) ||
        item.MemoSubject?.toLowerCase().includes(keyword) ||
        item[props.refAttribute?.optionLabel]?.toLowerCase().includes(keyword)
      );
    });

    setDisplayData(filtered);
  };

  return (
    <>
      <Dialog
        header={renderHeaderRefTemplate}
        visible={props.dialogVisibleInRefTemplate}
        style={{ width: "60vw", borderRadius: "16px" }}
        onShow={() => {
          // getRefDoc(); LPN ต้องการให้เรียก GetRefDoc ครั้งเดียวตอนที่โหลดหน้า Memo เลยไม่ต้องเรียกซ้ำตอนเปิด Dialog

          if (props.refTempSelected) {
            setRefSelected([...props.refTempSelected]);
          }
        }}
        onHide={onHide}
        dismissableMask
        className="information-dialog"
        blockScroll
        draggable={false}
        resizable={false}
        closable
      >
        <DataTable
          paginator
          rows={5}
          value={displayData}
          loading={loading}
          selection={refSelected}
          onSelectionChange={(e: any) => {
            onSelect(e.value);
          }}
          selectionMode={
            props.refAttribute?.mode.toLowerCase() === "single"
              ? "single"
              : "multiple"
          }
          dataKey={
            props.refAttribute?.optionLabel !== "Information DocumentNo"
              ? "MemoId"
              : "DocumentNo"
          }
          scrollable
          tableStyle={{
            border: "1px solid #e6e6e6",
            outlineColor: "#e6e6e6",
            minWidth: "-webkit-fill-available",
          }}
          sortField="DocumentNo"
          sortOrder={1}
        >
          <Column
            selectionMode={
              props.refAttribute?.mode.toLowerCase() === "single"
                ? "single"
                : "multiple"
            }
            style={{ minWidth: masterRefCol?.IsActive && masterRefCol?.Value1 ? "6rem" : "3rem" }}
          ></Column>
          {props.refAttribute?.optionLabel !== "Information DocumentNo" ? (
            <Column
              field="SelectField.value"
              header={
                <tr>
                  <th>
                    <p className="row headtext">
                      {props.refAttribute?.optionLabel}
                    </p>
                  </th>
                </tr>
              }
              style={{ minWidth: masterRefCol?.IsActive && masterRefCol?.Value1 ? "12rem" : "18rem" }}
              sortable
            ></Column>
          ) : (
            <Column
              field="DocumentNo"
              header={
                <tr>
                  <th>
                    <p className="row headtext">Document No.</p>
                    <p className="row subtext">รหัสเอกสาร</p>
                  </th>
                </tr>
              }
              style={{ minWidth: masterRefCol?.IsActive && masterRefCol?.Value1 ? "12rem" : "18rem" }}
              sortable
            ></Column>
          )}

          <Column
            field="TemplateName"
            header={
              <tr>
                <th>
                  <p className="row headtext">Form Template</p>
                  <p className="row subtext">ชื่อเอกสาร</p>
                </th>
              </tr>
            }
            style={{ minWidth: masterRefCol?.IsActive && masterRefCol?.Value1 ? "20rem" : "22rem" }}
          ></Column>
          <Column
            field="MemoSubject"
            header={
              <tr>
                <th>
                  <p className="row headtext">Subject</p>
                  <p className="row subtext">หัวข้อเอกสาร</p>
                </th>
              </tr>
            }
            style={{ minWidth: masterRefCol?.IsActive && masterRefCol?.Value1 ? "20rem" : "22rem" }}
          ></Column>

          {refColumnsDynamic()}
        </DataTable>
      </Dialog>
    </>
  );
};

export default DialogRefTemplateComponent;
